var _defs, _style, _use, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStateBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 212 69",
    width: 212,
    height: 69,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 212,
    height: 69,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANQAAABFAQMAAAAIKlq9AAAAAXNSR0IB2cksfwAAAANQTFRFyNj9sis7lAAAAB1JREFUeJxjZMANGEflRuVG5UblRuVG5UblaC4HAA+/AEbghmFHAAAAAElFTkSuQmCC"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #e4e4e4;stroke: #767d93;stroke-miterlimit:100 } \n\t")), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Background",
    href: "#img1",
    x: 67,
    y: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape 1",
    fillRule: "evenodd",
    className: "s0",
    d: "m61.25-46.8l33.22 145.25-166.69 38.13-33.22-145.25z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStateBackground);
export default __webpack_public_path__ + "static/media/stateBackground.488735761a34166bc7bda5c6d4ff9f14.svg";
export { ForwardRef as ReactComponent };